import { Spacing } from '@persona-id/design-tokens';
import {
  ErrorListProps,
  FormContextType,
  RJSFSchema,
  RJSFValidationError,
  StrictRJSFSchema,
} from '@rjsf/utils';
import { startCase } from 'lodash';
import styled from 'styled-components';

import Spacer from 'design-system/components/Spacer';

const ErrorListItem = styled.li`
  color: ${({ theme }) => theme.color.variants.danger.default};
  margin-left: ${Spacing[3]};
`;

/** The `ErrorList` component is the template that renders the all the errors associated with the fields in the `Form`
 *
 * @param props - The `ErrorListProps` for this component
 */
export function ErrorListTemplate<
  T = any,
  S extends StrictRJSFSchema = RJSFSchema,
  F extends FormContextType = any,
>({ errors }: ErrorListProps<T, S, F>) {
  return (
    <>
      <ul>
        {errors.map((error: RJSFValidationError, idx: number) => {
          const propertyName = error.property?.split('.').pop();
          const errorMessage = propertyName
            ? startCase(propertyName) + ': ' + error.message
            : error.message;

          return <ErrorListItem key={idx}>{errorMessage}</ErrorListItem>;
        })}
      </ul>
      <Spacer height={1} />
    </>
  );
}
